// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__ySxz2","tab":"Tabs_tab__17Gda","tabActive":"Tabs_tabActive__3yAy1"};